export default __webpack_public_path__ + "static/media/4.7f901c25.jpeg";